/**
 * Простая система событий для обновления баланса
 */

type EventCallback = () => void;

class EventEmitter {
    private events: { [key: string]: EventCallback[] } = {};

    on(event: string, callback: EventCallback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    off(event: string, callback: EventCallback) {
        if (!this.events[event]) return;
        this.events[event] = this.events[event].filter(cb => cb !== callback);
    }

    emit(event: string) {
        if (!this.events[event]) return;
        this.events[event].forEach(callback => callback());
    }
}

// Глобальный экземпляр для событий баланса
export const balanceEvents = new EventEmitter();

// События
export const BALANCE_EVENTS = {
    UPDATED: 'balance_updated',
    SETTINGS_CHANGED: 'settings_changed',
    PAYMENT_CONFIRMED: 'payment_confirmed',
    ORDER_CREATED: 'order_created',
    DEPOSIT_COMPLETED: 'deposit_completed',
} as const;
